import React, { useContext, useEffect } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { BackButton } from "../../components/BackButton";
import { ApplicationFormStateContext } from "../../state/applicationFormState";
import { trackEvent } from "../../utils/gtm";
import { scrollToTopOfContent } from "../../utils/scroll";
import { useNavigate } from "react-router-dom";
import { Step } from "../../models/Step";
import { saveStateRemote } from "../../utils/api";

const PayoutStep: React.FunctionComponent = () => {
  const [state, dispatch] = useContext(ApplicationFormStateContext);
  const { payoutAccountNumber, payoutClearingNumber } = state;
  const navigate = useNavigate();

  useEffect(() => {
    trackEvent({eventName: 'step_load', data: { step: 'Payout' } });
    dispatch({ type: 'set_step', step: Step.Payout });
    scrollToTopOfContent();

    const saveState = async () => {
          await saveStateRemote(state);
        };
        saveState();
  }, []);

  const validationSchema = yup.object().shape({
    payoutClearingNumber: yup
      .number()
      .typeError("Indtast reg. nr.")
      .min(0, "Indtast reg. nr.")
      .max(9999, "Indtast reg. nr.")
      .required("Indtast kontonr."),
      payoutAccountNumber: yup
      .number()
      .typeError("Indtast kontonr.")
      .min(0, "Indtast kontonr.")
      .max(9999999999, "Indtast kontonr.")
      .required("Indtast kontonr."),
  });

  return (
    <>
      <h2>Betaling</h2>
      <h3>
        Tilmeld din konto til Betalingsservice.
        <br />
        Din månedlige betaling til lånet skal betales via Betalingsservice.
      </h3>

      <Formik
        initialValues={{ payoutAccountNumber, payoutClearingNumber }}
        onSubmit={async (values) => {
          dispatch({
            type: "set_payout",
            payoutClearingNumber: values.payoutClearingNumber,
            payoutAccountNumber: values.payoutAccountNumber,
          });

          navigate("/betingelser");
        }}
        validationSchema={validationSchema}
      >
        {(formikProps) => (
          <div className="mt-5">
            <div>
              <label className="label-default">Kontonr.</label>
              <input
                type="text"
                name="payoutClearingNumber"
                // placeholder="Kontonr."
                defaultValue={formikProps.values.payoutClearingNumber}
                disabled={formikProps.isSubmitting}
                onChange={formikProps.handleChange}
                onBlur={formikProps.handleBlur}
                maxLength={4}
              />

              {(formikProps.touched.payoutClearingNumber ||
                formikProps.submitCount > 0) &&
                formikProps.errors.payoutClearingNumber && (
                  <div className="invalid-feedback">
                    {formikProps.errors.payoutClearingNumber}
                  </div>
                )}
            </div>

            <div className="mt-5">
              <label className="label-default">Reg. nr.</label>
              <input
                type="text"
                name="payoutAccountNumber"
                // placeholder="Reg. nr."
                defaultValue={formikProps.values.payoutAccountNumber}
                disabled={formikProps.isSubmitting}
                onChange={formikProps.handleChange}
                onBlur={formikProps.handleBlur}
                maxLength={10}
              />

              {(formikProps.touched.payoutAccountNumber ||
                formikProps.submitCount > 0) &&
                formikProps.errors.payoutAccountNumber && (
                  <div className="invalid-feedback">
                    {formikProps.errors.payoutAccountNumber}
                  </div>
                )}
            </div>

            <div className="container-btn">
              <BackButton />

              <button
                className="btn btn-next"
                type="submit"
                onClick={() => formikProps.submitForm()}
              >
                Næste
              </button>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};

export default PayoutStep;
